import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const otpInputDefaultVariants = {
  "size": "md",
  "status": "default",
  "active": false,
  "disabled": false,
  "fullWidth": false
}
const otpInputCompoundVariants = [
  {
    "status": "error",
    "active": true,
    "css": {
      "slot": {
        "borderColor": "critical.border.high",
        "backgroundColor": "critical.surface.base"
      }
    }
  },
  {
    "status": "warning",
    "active": true,
    "css": {
      "slot": {
        "borderColor": "warning.border.high",
        "backgroundColor": "warning.surface.base"
      }
    }
  },
  {
    "status": "success",
    "active": true,
    "css": {
      "slot": {
        "borderColor": "positive.border.high",
        "backgroundColor": "positive.surface.base"
      }
    }
  }
]

const otpInputSlotNames = [
  [
    "root",
    "otpInput__root"
  ],
  [
    "slotWrapper",
    "otpInput__slotWrapper"
  ],
  [
    "slot",
    "otpInput__slot"
  ],
  [
    "separator",
    "otpInput__separator"
  ],
  [
    "caret",
    "otpInput__caret"
  ],
  [
    "caretLine",
    "otpInput__caretLine"
  ]
]
const otpInputSlotFns = /* @__PURE__ */ otpInputSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, otpInputDefaultVariants, getSlotCompoundVariant(otpInputCompoundVariants, slotName))])

const otpInputFn = memo((props = {}) => {
  return Object.fromEntries(otpInputSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const otpInputVariantKeys = [
  "size",
  "status",
  "active",
  "disabled",
  "fullWidth"
]
const getVariantProps = (variants) => ({ ...otpInputDefaultVariants, ...compact(variants) })

export const otpInput = /* @__PURE__ */ Object.assign(otpInputFn, {
  __recipe__: false,
  __name__: 'otpInput',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: otpInputVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md",
    "lg"
  ],
  "status": [
    "default",
    "error",
    "warning",
    "success"
  ],
  "active": [
    "true"
  ],
  "disabled": [
    "true"
  ],
  "fullWidth": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, otpInputVariantKeys)
  },
  getVariantProps
})